import { TrackingAction } from './events';
import { actionCreatorWithIntegrationId } from '../utils/actionCreatorWithIntegrationId';

export const trackIntegrationEvent =
  actionCreatorWithIntegrationId<TrackingAction>(
    '[integrations] TRACK_INTEGRATION_EVENT'
  );
